var scope_0 = require('/home/runner/work/graphile.github.io/graphile.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/07118e3952e239c83e59984f5b448e66.js').default;
var scope_1 = require('/home/runner/work/graphile.github.io/graphile.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/206f95bae22b1168ef81b5fb98a13c4a.js').default;
var scope_2 = require('/home/runner/work/graphile.github.io/graphile.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b12b012149eb40a73f9d176f927432de.js').default;
var scope_3 = require('/home/runner/work/graphile.github.io/graphile.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c61d018ee559f5317686295f9a9c54cc.js').default;
var scope_4 = require('/home/runner/work/graphile.github.io/graphile.github.io/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f2786c48882d01f64860a86833b6efd8.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    